<script>

/**

This component counts how much time the user spends focused on its Seer account, and
sends a heartbeat to the server each HEARTBEAT_THRESHOLD milliseconds active.
Note that only the time with Seer focused is accounted as active. If the view is
blurred (the user changed tab, the browser is minimized, etc), the timer pauses.

*/

import api from '@/_api';

const HEARTBEAT_THRESHOLD = 60 * 1000; // milliseconds
const UPDATE_INTERVAL = 1000; // milliseconds
const INACTIVE_THRESHOLD = 15 * (60 * 1000); // milliseconds

export default {
  data() {
    return {
      timeout: null,
      waiting: false,
      lastProfilePk: null,

      activeMs: 0, // milliseconds active

      inactiveTimeout: null, // To detect continuous inactivity
    };
  },
  computed: {
    profile() {
      const { user } = this.$store.state.account;
      return user ? user.profile : null;
    },
    isSuperuser() {
      return this.$store.getters['account/isSuperuser'];
    },
  },
  watch: {
    '$store.state.account.user': {
      handler(newval) {
        if (newval && newval.profile) {
          if (newval.profile.pk !== this.lastProfilePk) {
            this.lastProfilePk = newval.profile.pk;
            console.log('New user login. Start loop');
            this.activeMs = 0;
            this.startLoop();
          }
        } else {
          console.debug('Stopping heartbeat');
          this.stopLoop();
        }
      },
    },
  },
  mounted() {
    // Prevents sending heartbeats
    if (this.isSuperuser) {
      return;
    }
    // if (this.profile && !this.timeout){
    //   this.startLoop()
    // }
    window.addEventListener('focus', () => {
      console.debug('Seer focused');
      this.startLoop();
    });
    window.addEventListener('blur', () => {
      console.debug(`Seer focus lost. Will stop counter in ${Math.round(INACTIVE_THRESHOLD / 1000)}s`);
      this.inactiveStarted();
    });
  },
  beforeUnmount() {
    this.stopLoop();
    this.waiting = false;
    if (this.inactiveTimeout) {
      window.clearTimeout(this.inactiveTimeout);
      this.inactiveTimeout = null;
    }
  },
  methods: {
    startLoop() {
      if (this.isTokenLogin()) {
        console.warn('Heartbeat loop disabled for token sessions.');
        return;
      }
      if (this.inactiveTimeout) {
        window.clearTimeout(this.inactiveTimeout);
        this.inactiveTimeout = null;
      }
      if (this.timeout) {
        return;
      }
      const loop = () => {
        if (!this.profile) {
          // User no longer valid. Stop
          this.stopLoop();
          return;
        }
        // Increase time active
        this.activeMs += UPDATE_INTERVAL;
        if (this.activeMs >= HEARTBEAT_THRESHOLD) {
          console.log('Sending heartbeat!');
          this.beat();
          this.activeMs -= HEARTBEAT_THRESHOLD;
        }
        this.timeout = window.setTimeout(loop, UPDATE_INTERVAL);
      };
      console.debug('Starting heartbeat counter');
      loop();
    },
    inactiveStarted() {
      this.inactiveTimeout = window.setTimeout(this.stopLoop, INACTIVE_THRESHOLD);
    },
    stopLoop() {
      if (this.timeout) {
        console.debug(`Heartbeat counter stopped. Current activity is ${Math.round(this.activeMs / 1000)}s`);
        window.clearTimeout(this.timeout);
        this.timeout = null;
      }
    },
    beat() {
      if (this.isTokenLogin()) {
        console.warn('Heartbeat ignored as this is a token login session');
        return;
      }
      if (this.waiting) {
        console.warn(`heartbeat ignored. Sent one ${this.$moment().fromNow()}`);
        return;
      }
      if (!this.profile || !this.profile.pk) {
        console.warn('Whoops, heartbeat could not be sent: Invalid profile');
        return;
      }
      this.waiting = this.$moment();
      api.post(`/profile/${this.profile.pk}/heartbeat/`)
        .then((response) => {
        }).catch((error) => {
          console.error('Could not send heartbeat: ', error);
        }).finally(() => {
          this.waiting = null;
        });

      this.$store.dispatch('version/getCurrent');
    },
    isTokenLogin() {
      return JSON.parse(localStorage.getItem('isTokenLogin'));
    },
  },
};

</script>
